import * as actionTypes from "../actions/actionTypes";

const initialState = {
  actions: {
    sort: {
      sortBy: "",
      sortOrder: "",
    },
    filter: {
      filterBy: "",
      filtersDoc: {},
    },
  },
  objectives: {
    sort: {
      sortBy: "",
      sortOrder: "",
    },
    filter: {
      filterBy: "",
    },
  },
  groupMetrics: {
    sort: {
      sortBy: "",
      sortOrder: "",
    },
    filter: {
      filtersDoc: {},
    },
  },
  triviaList: {
    sort: {
      sortBy: "",
      sortOrder: "",
    },
    filter: {
      filtersDoc: {},
    },
  },
  triviaMessages: {
    sort: {
      sortBy: "",
      sortOrder: "",
    },
    filter: {
      filtersDoc: {},
    },
  },
  myTrivia: {
    sort: {
      sortBy: "",
      sortOrder: "",
    },
  },
  triviaLibraryList: {
    sort: {
      sortBy: "",
      sortOrder: "",
    },
  },
  triviaResultList: {
    sort: {
      sortBy: "",
      sortOrder: "",
    },
  },
  libraryQuestionsList: {
    sort: {
      sortBy: "",
      sortOrder: "",
    },
  },
};

export default function(state = initialState, action) {
  switch (action.type) {
    case actionTypes.UPDATE_ACTION_SORT:
      return {
        ...state,
        actions: {
          ...state.actions,
          sort: action.val,
        },
      };
    case actionTypes.UPDATE_ACTION_FILTER:
      return {
        ...state,
        actions: {
          ...state.actions,
          filter: action.val,
        },
      };
    case actionTypes.UPDATE_OBJECTIVE_SORT:
      return {
        ...state,
        objectives: {
          ...state.objectives,
          sort: action.val,
        },
      };
    case actionTypes.UPDATE_OBJECTIVE_FILTER:
      return {
        ...state,
        objectives: {
          ...state.objectives,
          filter: action.val,
        },
      };
    case actionTypes.UPDATE_GROUP_METRICS_SORT:
      return {
        ...state,
        groupMetrics: {
          ...state.groupMetrics,
          sort: action.val,
        },
      };
    case actionTypes.UPDATE_GROUP_METRICS_FILTER:
      return {
        ...state,
        groupMetrics: {
          ...state.groupMetrics,
          filter: action.val,
        },
      };

    case actionTypes.UPDATE_TRIVIA_SORT:
      return {
        ...state,
        triviaList: {
          ...state.triviaList,
          sort: action.val,
        },
      };
    case actionTypes.UPDATE_TRIVIA_RESULT_SORT:
      return {
        ...state,
        triviaResultList: {
          ...state.triviaResultList,
          sort: action.val,
        },
      };

    case actionTypes.UPDATE_MY_TRIVIA_SORT:
      return {
        ...state,
        myTrivia: {
          ...state.myTrivia,
          sort: action.val,
        },
      };

    case actionTypes.UPDATE_LIBRARY_SORT:
      return {
        ...state,
        triviaLibraryList: {
          ...state.triviaLibraryList,
          sort: action.val,
        },
      };
    case actionTypes.UPDATE_LIBRARY_QUESTIONS_SORT:
      return {
        ...state,
        libraryQuestionsList: {
          ...state.libraryQuestionsList,
          sort: action.val,
        },
      };

    default:
      break;
  }
  return state;
}
